import {Model} from '../Models';

export function formatPrice(price: number | string): string {
  if (typeof price === 'number') {
    return price.toFixed(2).replace('.', ',');
  }
  return price.replace('.', ',');
}

export function getTimeString(language: string, date: Date): string {
  const options = {hour: 'numeric', minute: 'numeric'};
  // @ts-ignore
  return new Date(date).toLocaleTimeString(language, options);
}

export function getDateString(language: string, date: Date): string {
  const options = {weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric'};
  // @ts-ignore
  return new Date(date).toLocaleDateString(language, options);
}

export function asAPIDateString(date: Date): string {
  // convert to utc before sending to API
  const utcDate = createDateAsUTC(date);
  return utcDate.toISOString().replace('T', ' ').split('.')[0];
}

export function createDateAsUTC(date: Date): Date {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
}

export function mergeModelArray<T extends Model>(a1: Array<T>, a2: Array<T>) {
  const m = a1.concat(a2);
  return [...new Map(m.map(i => [i.id, i])).values()];
}
